import Modal from 'bootstrap/js/src/modal';
import {parseHTML} from "../Core/common";

import {Validator} from "../Core/validator";


import intlTelInput from 'intl-tel-input';
import intlRu from "intl-tel-input/i18n/ru"

let config = {
    'size': '',
    'title': '',
    'message': '',
    'footer': '',
    'header': function () {
        return `<div class="modal-header">${this.title}
                ${this.closeBtm}</div>`;
    },
    'closeBtm': `<button 
                        type="button" 
                        style="z-index: 1;"
                        class="btn-close" 
                        data-bs-dismiss="modal" 
                        aria-label="Close"
                    >
                </button>`,
    showEvent: function () {
    },
    hiddenEvent: function () {
    },
    hideEvent: function () {
    },
};


export const modal = (options, showEvent, hiddenEvent) => {
    if (Validator.isString(options)) {
        options = {'message': options};
    }
    if (showEvent) {
        options.showEvent = showEvent;
    }
    if (hiddenEvent) {
        options.hiddenEvent = hiddenEvent;
    }
    let modalConfig = {...config, ...options};

    modalBuilder(modalConfig, showEvent, hiddenEvent, hiddenEvent);
};


const modalBuilder = (options) => {
    document.querySelectorAll('.modal').forEach(t => {
        let modal = Modal.getInstance(t);
        if (modal) {
            modal.hide();
        }
        t.remove();
    });

    let element = parseHTML(`<div class="modal fade modal-call" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog  ${options.size}">
        <div class="modal-content">
            ${options.header.call(options)}
            <div class="modal-body">
                ${options.message}
            </div>
             ${options.footer}
        </div>
    </div>
</div>`);

    document.querySelector('body').append(element);


    let to = document.querySelector('.modal');

    let modal = new Modal(to);
    modal.show();

    to.querySelectorAll('input[type="tel"]').forEach(input => {

        let wrapperBlock = input.closest('label');
        let parentBlock = wrapperBlock.parentElement;
        let country = document.createElement('div');
        country.classList.add('main-input__country');
        parentBlock.insertBefore(country, wrapperBlock.nextSibling);
        let iti = intlTelInput(input, {
            loadUtils: () => import("intl-tel-input/utils"),
            i18n: intlRu,
            initialCountry: "ru",
            autoPlaceholder: "aggressive",
            separateDialCode: true,
            strictMode: true,
            dropdownContainer: parentBlock.querySelector('.main-input__country'),
            // hiddenInput: (telInputName) => ({
            //     phone: "phone_full",
            //     country: "country_code"
            // }),
        });

        input.addEventListener("input", () => {
            input.dataset.country_code = iti.getNumber(intlTelInput.utils.numberFormat.E164);
        });

        input.style.paddingLeft = `71px`;


    })
    let show = (event) => {
        if (options.showEvent) {
            options.showEvent(to, modal, event, options);
        }

    };

    let hide = event => {
        if (options.hideEvent) {
            options.hideEvent(to, modal, event);
        }
    };

    let hiden = event => {
        to.remove();
        to.removeEventListener('shown.bs.modal', show);
        to.removeEventListener('hidden.bs.modal', hiden);
        to.removeEventListener('hide.bs.modal', hide);
        if (options.hiddenEvent) {
            options.hiddenEvent(event);
        }
    };


    to.addEventListener('shown.bs.modal', show);
    to.addEventListener('hidden.bs.modal', hiden);
    to.addEventListener('hide.bs.modal', hide);
};